import Transform from "@ember-data/serializer/transform";
import ConsultationReportWrittenQuestion from "parog-web/models/consultation/consultation-report-written-question";

export default class ConsultationReportWrittenQuestionsTransform extends Transform {
  override deserialize(serialized) {
    return serialized?.map(
      item =>
        new ConsultationReportWrittenQuestion(
          item["key"],
          item["issue"],
          item["answer"]
        )
    );
  }

  override serialize(deserialized) {
    const result = deserialized?.map(item => {
      return {
        key: item.key,
        issue: item.issue,
        answer: item.answer
      };
    });

    return result;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "consultation-report-written-questions": ConsultationReportWrittenQuestionsTransform;
  }
}
